import { Route, Router } from 'preact-router'
import { Fragment, FunctionalComponent, h } from 'preact'

import Survey from './pages/survey'
import Feedback from './pages/feedback'
import Reply from './pages/reply'

import './style/index.scss'
import resetCss from './style/reset'
import appStyle from './style/app.module.scss'

const AppRouter: FunctionalComponent = () => {
  return (
    <Fragment>
      <style>{resetCss}</style>
      <div className={appStyle.app}>
        <Router>
          <Route path="/xs/u/:token" component={Survey} isUrlVisit />
          <Route path="/xn/u/:token" component={Survey} isUrlVisit />
          <Route path="/xf/u/:token" component={Feedback} isUrlVisit />
          <Route path="/xr/u/:token" component={Reply} isUrlVisit />
          <Route path="/xs/:token" component={Survey} />
          <Route path="/xn/:token" component={Survey} />
          <Route path="/xf/:token" component={Feedback} />
          <Route path="/xr/:token" component={Reply} />
        </Router>
      </div>
    </Fragment>
  )
}

export default AppRouter
